import Vue from 'vue'
import Router from 'vue-router'
import { LoadingBar } from 'view-design'
import wj from '@/plugins/wjtools'
import home from './home'

Vue.use(Router)

// 修改路由 push 方法，禁止跳转相同路由时报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

// 创建路由实例
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // scrollBehavior: (to, from, savedPosition) => (savedPosition || { x: 0, y: 0 }),
  scrollBehavior: (to, from, savedPosition) => {
    // 兼容线路列表页动态修改 url 的 query 参数导致滚动条重置问题
    if (to.path === from.path && to.path === '/quote-price') {
      return {}
    }
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    ...home,
    {
      path: '/*',
      redirect: '/',
    },
  ],
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  LoadingBar.start()

  // 登录权限控制
  if (to.meta.needAuth && !wj.isLogin()) {
    LoadingBar.finish()
    router.replace('/')
    wj.login()
    return
  }

  next()
})

// 全局后置守卫
router.afterEach((to, from) => {
  LoadingBar.finish()

  if (to.meta.title) document.title = to.meta.title
  // window.scrollTo(0, 0)
})

// 监听路由报错
router.onError((err) => {
  console.warn(`路由出错：${err}`)
})

export default router
